import Image from "next/image";
import Link from "next/link";
import React from "react";
import { getNftImageFromCDN } from "../../helpers/helperConstants";
import { normalizeEther } from "../../helpers/digits";
import { getTokenName } from "../../helpers/getChainName";

const getOffersWithName = (offers) => {
  return offers?.map((offer) => {
    const item = offer?.item;
    let metadata = item?.metadata;
    metadata = typeof metadata === "string" ? JSON.parse(metadata) : metadata;
    return {
      ...offer,
      item: {
        ...item,
        name: item.name || metadata?.name,
      },
    };
  });
};

const Collection_category = ({
  bgWhite = false,
  latestOffers,
  topOffers,
  lastListed,
}) => {
  lastListed = getOffersWithName(lastListed);
  latestOffers = getOffersWithName(latestOffers);
  topOffers = getOffersWithName(topOffers);
  const collectionCategoryData = [
    {
      parentId: 1,
      name: "Last Listed",
      collections: lastListed || [],
      // collections: [
      //   {
      //   	id: 1,
      //   	title: 'NFT Funny Cat',
      //   	image: '/images/avatars/avatar_1.jpg',
      //   	amount: '7,080.95',
      //   	postTime: '2022-07-20',
      //   },
      //   {
      //   	id: 2,
      //   	title: 'Cryptopank',
      //   	image: '/images/avatars/avatar_2.jpg',
      //   	amount: '6,548,133',
      //   	postTime: '2022-07-10',
      //   },
      //   {
      //   	id: 3,
      //   	title: 'Prince Ape Planet',
      //   	image: '/images/avatars/avatar_3.jpg',
      //   	amount: '4,823,927',
      //   	postTime: '2022-07-08',
      //   },
      //   {
      //   	id: 4,
      //   	title: 'Hey Mrsmeseks',
      //   	image: '/images/avatars/avatar_4.jpg',
      //   	amount: '3,186',
      //   	postTime: '2022-07-01',
      //   },
      // ],
    },
    {
      parentId: 2,
      name: "Latest Offers",
      collections: latestOffers || [],
      // collections: [
      // 	{
      // 		id: 5,
      // 		title: 'Bored Bunny',
      // 		image: '/images/avatars/avatar_5.jpg',
      // 		amount: '3,027',
      // 		postTime: '2022-07-05',
      // 	},
      // 	{
      // 		id: 6,
      // 		title: 'Wow Frens',
      // 		image: '/images/avatars/avatar_6.jpg',
      // 		amount: '2,586',
      // 		postTime: '2022-07-08',
      // 	},
      // 	{
      // 		id: 7,
      // 		title: 'Origin Morish',
      // 		image: '/images/avatars/avatar_7.jpg',
      // 		amount: '2,347.85',
      // 		postTime: '2022-07-20',
      // 	},
      // 	{
      // 		id: 8,
      // 		title: 'Superdo',
      // 		image: '/images/avatars/avatar_8.jpg',
      // 		amount: '2,115.71',
      // 		postTime: '2022-07-10',
      // 	},
      // ],
    },
    {
      parentId: 3,
      name: "Top Offers",
      collections: topOffers || [],
      //   collections: [
      //     {
      //     	id: 9,
      //     	title: 'NFT stars',
      //     	image: '/images/avatars/avatar_9.jpg',
      //     	amount: '2,027',
      //     	postTime: '2022-07-12',
      //     },
      //     {
      //     	id: 10,
      //     	title: 'Asumitsu',
      //     	image: '/images/avatars/avatar_10.jpg',
      //     	amount: '1,989.70',
      //     	postTime: '2022-07-15',
      //     },
      //     {
      //     	id: 11,
      //     	title: 'Pank Skull',
      //     	image: '/images/avatars/avatar_11.jpg',
      //     	amount: '1,726.70',
      //     	postTime: '2022-07-16',
      //     },
      //     {
      //     	id: 12,
      //     	title: 'Lazy Panda',
      //     	image: '/images/avatars/avatar_12.jpg',
      //     	amount: '1,589.03',
      //     	postTime: '2022-07-14',
      //     },
      //   ],
    },
  ];

  return (
    <div>
      {/* <!-- Today's Drops / Sellers / Buyers --> */}
      <section className="py-24 relative">
        {bgWhite && (
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
            <Image
              src="/images/gradient_light.jpg"
              alt="gradient"
              className="h-full"
              layout="fill"
            />
          </picture>
        )}
        <div className="container">
          <div className="flex flex-col space-y-5 lg:flex-row lg:space-y-0 lg:space-x-7">
            {collectionCategoryData.map(({ parentId, name, collections }) => {
              return (
                <div
                  className="dark:bg-jacarta-800 bg-light-base rounded-2.5xl p-12 lg:w-1/3"
                  key={parentId}
                >
                  <h2 className="text-jacarta-700 font-display mb-8 text-center text-3xl font-semibold dark:text-white">
                    {name}
                  </h2>

                  <div className="flex flex-col space-y-5">
                    {collections.map((c) => {
                      const {
                        id,
                        nftAddress,
                        colleteralTokenID,
                        paymentTokenName,
                        title,
                        icon,
                        amount,
                        borrowAmount,
                        postTime,
                        collection,
                        item,
                      } = c;
                      //   const { coverPhoto, headerPhoto, profilePhoto, ...rest } = collection;
                      const itemLink = nftAddress + "/" + colleteralTokenID;
                      const image = getNftImageFromCDN({
                        imageFtpPath: item.imageFtpPath,
                        isDNFT: collection.isDNFT,
                        tokenId: colleteralTokenID,
                        collectionInfo: collection,
                        metadata: item.metadata,
                        imagesize: "thumbnail",
                      });

                      return (
                        <div
                          key={id}
                          className="border-jacarta-100 dark:bg-jacarta-700 rounded-2xl flex border bg-white py-4 px-7 transition-shadow hover:shadow-lg dark:border-transparent"
                        >
                          <figure className="mr-4 shrink-0">
                            <Link href={"/lend/" + itemLink}>
                              <a className="relative block">
                                <img
                                  src={image}
                                  alt={item.name}
                                  className="rounded-2lg h-12 w-12"
                                />
                                {/* <div className="dark:border-jacarta-600 bg-jacarta-700 absolute -left-3 top-1/2 flex h-6 w-6 -translate-y-2/4 items-center justify-center rounded-full border-2 border-white text-xs text-white">
																	{id}
																</div> */}
                              </a>
                            </Link>
                          </figure>
                          <div>
                            <Link href={"/lend/" + itemLink}>
                              <a className="block">
                                <span className="font-display text-jacarta-700 hover:text-accent font-semibold dark:text-white">
                                  {item.name}
                                </span>
                              </a>
                            </Link>
                            <span className="dark:text-jacarta-300 text-sm">
                              {normalizeEther(borrowAmount)} {paymentTokenName}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  {/* <Link href="/collection/avatar_1">
										<a className="text-accent mt-8 block text-center text-sm font-bold tracking-tight">
											View All
										</a>
									</Link> */}
                </div>
              );
            })}
          </div>
        </div>
      </section>
      {/* <!-- end today's drops / sellers / buyers --> */}
    </div>
  );
};

export default Collection_category;
